import React from "react";
import {
  FaTrophy,
  FaGraduationCap,
  FaUserCircle,
  FaEnvelope,
  FaLinkedin,
  FaMapMarkerAlt,
  FaGlobe,
} from "react-icons/fa";
import "./TealSidebar.css";

const TealSidebarTemplate = ({ resumeData }) => {
  if (!resumeData) return <div className="ts-loading">Loading...</div>;

  const {
    personal = {},
    education = [],
    experience = [],
    skills = {},
    achievements = [],
  } = resumeData;

  return (
    <div className="ts-wrapper">
      {/* LEFT CONTENT AREA */}
      <div className="ts-content-main">
        <header className="ts-main-header">
          <h1 className="ts-user-name">
            {personal.fullName || "ALEX JOHNSON"}
          </h1>
          <p className="ts-user-role">
            {personal.title || "Software Engineer"}
          </p>
          <div className="ts-contact-info">
            {personal.email && (
              <span>
                <FaEnvelope className="ts-contact-icon" /> {personal.email}
              </span>
            )}
            <span>
              <FaLinkedin className="ts-contact-icon" /> LinkedIn/Portfolio
            </span>
            {personal.address && (
              <span>
                <FaMapMarkerAlt className="ts-contact-icon" />{" "}
                {personal.address}
              </span>
            )}
          </div>
        </header>

        <section className="ts-main-section">
          <h3 className="ts-section-heading">SUMMARY</h3>
          <p className="ts-summary-text">
            {personal.summary || "Professional summary goes here..."}
          </p>
        </section>

        <section className="ts-main-section">
          <h3 className="ts-section-heading">EXPERIENCE</h3>
          {experience.map((exp, i) => (
            <div key={i} className="ts-experience-item">
              <div className="ts-exp-header">
                <span className="ts-bold">{exp.title}</span>
                <span className="ts-date-text">
                  {exp.startDate} — {exp.endDate}
                </span>
              </div>
              <div className="ts-exp-sub">
                <span className="ts-accent">{exp.company}</span>
                <span className="ts-gray-text">{exp.location}</span>
              </div>
              <ul className="ts-exp-bullets">
                {exp.description?.split("\n").map((line, j) => (
                  <li key={j}>{line}</li>
                ))}
              </ul>
            </div>
          ))}
        </section>
      </div>

      {/* RIGHT SIDEBAR (TEAL) */}
      <aside className="ts-right-sidebar">
        <div className="ts-profile-container">
          {personal.photo ? (
            <img
              src={personal.photo}
              alt="Profile"
              className="ts-profile-img"
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "block";
              }}
            />
          ) : null}
          <FaUserCircle
            className="ts-avatar-placeholder"
            style={{ display: personal.photo ? "none" : "block" }}
          />
        </div>

        <section className="ts-side-section">
          <h3 className="ts-side-heading">KEY ACHIEVEMENTS</h3>
          {achievements.map((ach, i) => (
            <div
              key={i}
              className={`ts-ach-card ${i === achievements.length - 1 ? "ts-highlight-box" : ""}`}
            >
              <FaTrophy className="ts-side-icon" />
              <p className="ts-ach-detail">{ach}</p>
            </div>
          ))}
        </section>

        <section className="ts-side-section">
          <h3 className="ts-side-heading">SKILLS</h3>
          <div className="ts-skill-tags">
            {skills.technical?.map((s, i) => (
              <span key={i} className="ts-skill-pill">
                {s}
              </span>
            ))}
          </div>
        </section>

        <section className="ts-side-section">
          <h3 className="ts-side-heading">EDUCATION</h3>
          {education.map((edu, i) => (
            <div key={i} className="ts-side-edu">
              <p className="ts-bold-white">{edu.degree}</p>
              <p className="ts-side-subtext">{edu.institution}</p>
              <p className="ts-side-date">{edu.year}</p>
            </div>
          ))}
        </section>
      </aside>
    </div>
  );
};

export default TealSidebarTemplate;
